function MathematicalSet()
{
	this.length = 0;
	this.elements = {};
	
	for (var i = 0; i < arguments.length; i++)
	{
		if (arguments[i] == null)
		{
			continue;
		}
		
		this.add(arguments[i]);
	}
};

MathematicalSet.prototype.isMathematicalSet = true;

MathematicalSet.prototype.add = function(element, dontEncode)
{
	if (element != null && !this.contains(element, dontEncode))
	{
		this.elements[dontEncode ? element : JSON.stringify(element)] = true; 
		this.length++; 
	}
	
	return this; 
};

MathematicalSet.prototype.addContents = function(elements, keysOrValues)
{
	if (elements != null)
	{
		if (elements.isMathematicalSet === true)
		{
			for (var element in elements.elements)
			{
				this.add(element, true);
			}
		}
		else if (elements.constructor === Array)
		{
			for (var i = 0; i < elements.length; i++)
			{
				this.add(elements[i]);
			}
		}
		else if (elements.constructor === Object)
		{
			var useKeyOrValue = false; //true: key, false: value
			if (typeof keysOrValues !== 'undefined')
			{
				if (typeof keysOrValues === 'boolean')
				{
					useKeyOrValue = keysOrValues;
				}
				else if (typeof keysOrValues === 'string')
				{
					var keysOrValuesMatch = keysOrValues.match(/^(keys?|values?)$/i);
					if (keysOrValuesMatch)
					{
						useKeyOrValue = keysOrValuesMatch[0].toLowerCase() === 'k';
					}
				}
			}
			
			for (var elementKey in elements)
			{
				if (elements.hasOwnProperty(elementKey))
				{
					this.add(useKeyOrValue ? elementKey : elements[elementKey]);
				}
			}
		}
		else
		{
			this.add(elements);
		}
	}
	
	return this; 
}

MathematicalSet.prototype.remove = function(element, dontEncode)
{
	if (this.contains(element, dontEncode))
	{
		delete this.elements[dontEncode ? element : JSON.stringify(element)]; 
		this.length--; 
	}
	
	return this; 
};

MathematicalSet.prototype.contains = function(element, dontEncode)
{
	if (typeof element === 'undefined')
	{
		return this.length > 0;
	}
	
	return this.elements.hasOwnProperty(dontEncode ? element : JSON.stringify(element)); 
};

MathematicalSet.prototype.intersect = function(otherSet)
{
	if (otherSet == null || !otherSet.isMathematicalSet)
	{
		return 'Parameter "otherSet" must be a Set';
	}

	var intersectionSet = new MathematicalSet();
	if (otherSet.length <= this.length)
	{
		for (var element in otherSet.elements)
		{
			if (this.contains(element, true))
			{
				intersectionSet.add(element, true);
			}
		}
	}
	else
	{
		for (var element in this.elements)
		{
			if (otherSet.contains(element, true))
			{
				intersectionSet.add(element, true);
			}
		}
	}
	
	return intersectionSet;
};

MathematicalSet.prototype.union = function(otherSet)
{
	if (!otherSet.isMathematicalSet || otherSet == null)
	{
		return 'Parameter "otherSet" must be a Set';
	}

	return new MathematicalSet().addContents(this).addContents(otherSet);
};

MathematicalSet.prototype.subtract = function(otherSet)
{
	if (!otherSet.isMathematicalSet || otherSet == null)
	{
		return 'Parameter "otherSet" must be a Set';
	}

	var subtraction = new MathematicalSet();
	
	for (var element in this.elements)
	{
		if (!otherSet.contains(element, true))
		{
			subtraction.add(element, true);
		}
	}

	return subtraction;
};

MathematicalSet.prototype.cartesianProduct = function(otherSet)
{
	if (!otherSet.isMathematicalSet || otherSet == null)
	{
		return 'Parameter "otherSet" must be a Set';
	}
	
	var cartesianProduct = new MathematicalSet();
	
	for (var element in this.elements)
	{
		for (var otherElement in otherSet.elements)
		{
			cartesianProduct.add([JSON.parse(element), JSON.parse(otherElement)]);
		}
	}
	
	return cartesianProduct;
}

MathematicalSet.prototype.toArray = function()
{
	var arr = [];
	
	for (var element in this.elements)
	{
		arr.push(JSON.parse(element));
	}

	return arr;
};

MathematicalSet.prototype.valueOf = function() 
{
	return this.toArray();
};
